import { render, staticRenderFns } from "./fuwurenci.vue?vue&type=template&id=5af898bb&"
import script from "./fuwurenci.vue?vue&type=script&lang=ts&"
export * from "./fuwurenci.vue?vue&type=script&lang=ts&"
import style0 from "./fuwurenci.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports